import { EventVm, MatchCoachVm, MatchDetailVm, UpdateEventCommand } from '../../../../utils/api';
import Card from './Card';

interface OwnProps {
    isHomeTeam: boolean;
    event: UpdateEventCommand;
    match?: MatchDetailVm;
    coaches: MatchCoachVm[];
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default Card;
